module.exports = {
  currency: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/,
  alphabet: /^[A-z0-9._]+$/
}



// WEBPACK FOOTER //
// ./src/assets/js/regex.js